/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Collapse } from 'react-bootstrap';
import {
  Editor,
  EditorState,
  ContentState,
} from 'draft-js';
import ShowIf from 'loracoms/ShowIf';
import Editable from 'loracoms/Editable';
import AutoColor from 'loracoms/AutoColor';
import FormBlock from 'loracoms/FormBlock';
import { callAPI } from 'lorautils/api';
import ErrorSet from 'lorautils/errors/ErrorSet';
import IntlMsg from 'lorautils/intl/IntlMsg';
import flowActions from 'loraactions/flow';
import DeleteFlowModal from '../DeleteFlowModal';
import AddFlowHelp from '../AddFlowHelp';
import styles from './styles.scss';

const kKeywords = [
  'info',
  'warn',
  'error',
  'success',
  'repeat',
  'window',
  'sum',
  'avg',
  'max',
  'min',
  'count',
];

const propTypes = {
  flow: React.PropTypes.object.isRequired,
  intl: React.PropTypes.object.isRequired,
  getFlows: React.PropTypes.func.isRequired,
  appId: React.PropTypes.string.isRequired,
};

class Flow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flow: props.flow,
      scriptState: EditorState.createEmpty(),
      errors: ErrorSet.createEmpty(),
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditScript = this.handleEditScript.bind(this);
    this.handleChangeScript = this.handleChangeScript.bind(this);
    this.handleSubmitScript = this.handleSubmitScript.bind(this);
    this.handleDeleted = this.handleDeleted.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.flowsview.flows');
  }

  componentWillReceiveProps(nextProps) {
    const { flow } = nextProps;
    if (flow !== this.props.flow) {
      this.setState({ flow });
    }
  }

  handleEdit() {
    const { flow, errors } = this.state;
    this.setState({
      edit: true,
      editData: { ...flow },
      errors: errors.remove('name'),
    });
    this.dirtyIds = [];
  }

  handleChange(editData, id) {
    this.setState({ editData });
    this.dirtyIds.push(id);

    if (id === 'name') {
      const { errors } = this.state;
      if (editData.name === '') {
        this.setState({ errors: errors.add('FE_EMPTY', 'name') });
      } else {
        this.setState({ errors: errors.remove('name') });
      }
    }
  }

  handleSubmit() {
    const { editData, flow, errors } = this.state;
    if (errors.has('name')) {
      return;
    }

    const changeData = _.fromPairs(_.filter(
      _.toPairs(editData),
      p => this.dirtyIds.includes(p[0]),
    ));

    if (!_.isEmpty(changeData)) {
      callAPI({
        endpoint: `/lora/flows/${flow.id}`,
        body: changeData,
        method: 'PUT',
      }).then(() => {
        this.setState({
          edit: false,
          flow: {
            ...flow,
            ...changeData,
          },
        });
      }).catch((error) => {
        this.setState({ errors: errors.add(error.code, 'submitBasic') });
      });
    } else {
      this.setState({ edit: false });
    }
  }

  handleEditScript() {
    const { flow, errors } = this.state;
    this.setState({
      editScript: true,
      showHelp: false,
      scriptState: (
        EditorState.createWithContent(
          ContentState.createFromText(flow.script))),
      errors: errors.remove('script'),
    });
  }

  handleChangeScript(scriptState) {
    this.setState({ scriptState });

    const { errors } = this.state;
    if (scriptState.getCurrentContent().getPlainText().trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'script') });
    } else {
      this.setState({ errors: errors.remove('script') });
    }
  }

  handleSubmitScript() {
    const { scriptState, flow, errors } = this.state;
    if (errors.has('script')) {
      return;
    }

    const script = scriptState.getCurrentContent().getPlainText();
    callAPI({
      endpoint: `/lora/flows/${flow.id}`,
      body: { script },
      method: 'PUT',
    }).then(() => {
      this.setState({
        editScript: false,
        flow: {
          ...flow,
          script,
        },
        errors: errors.remove('submitScript'),
      });
    }).catch((error) => {
      this.setState({
        errors: errors.add(error.code, 'submitScript'),
      });
    });
  }

  handleDeleted() {
    const { getFlows, appId } = this.props;
    getFlows(appId);
  }

  render() {
    const {
      flow,
      edit = false,
      editData = {},
      editScript = false,
      editScriptData = {},
      scriptState,
      showHelp = false,
      errors,
      showDelete = false,
    } = this.state;
    return (
      <div className={styles.container}>
        <div className={styles.flow}>
          <div className={`${styles.block} ${styles.basic}`}>
            <div className={styles.name}>
              <Editable
                id="name"
                value={flow.name}
                edit={edit}
                data={editData}
                error={this.intlMsg.errorMsg(errors.get('name'))}
                onChange={this.handleChange}
              />
            </div>
            <div className={styles.desc}>
              <Editable
                id="desc"
                value={flow.desc}
                edit={edit}
                data={editData}
                onChange={this.handleChange}
              />
            </div>
            <ShowIf if={!edit}>
              <div className={styles.actions}>
                <Link
                  className={styles.delete}
                  onClick={() => this.setState({ showDelete: true })}
                >
                  <span className="glyphicons glyphicons-remove-sign" />
                </Link>
                <Link
                  className={styles.edit}
                  onClick={this.handleEdit}
                >
                  <span className="glyphicons glyphicons-pencil" />
                </Link>
              </div>
            </ShowIf>
            <ShowIf if={edit}>
              <div className={styles.actions}>
                <Link className={styles.ok} onClick={this.handleSubmit}>
                  <span className="glyphicons glyphicons-ok" />
                </Link>
                <Link className={styles.cancel} onClick={() => this.setState({ edit: false })}>
                  <span className="glyphicons glyphicons-remove" />
                </Link>
              </div>
            </ShowIf>
          </div>
          <div className={`${styles.block} ${styles.rule} ${errors.has('script') ? styles.hasError : ''}`}>
            <Editable
              id="script"
              edit={editScript}
              data={editScriptData}
              value={flow.script}
              formatter={x => (
                <div>
                  {_.flatMap(x.split('|'), (expr, idx) => {
                    if (idx === 0) {
                      return [(
                        <AutoColor
                          key={`e-${idx}`}
                          className={`${styles.source} ${expr.trim().length === 1 ? styles.circle : ''}`}
                          content={expr.trim()}
                        >
                          {expr}
                        </AutoColor>
                      )];
                    }
                    let firstKw = expr.trim().split(' ')[0].toLowerCase();
                    if (!kKeywords.includes(firstKw)) {
                      firstKw = null;
                    }
                    return [
                      <i key={`s-${idx}`} className={` fa fa-long-arrow-right ${styles.arrow} `} />,
                      <span
                        key={`e-${idx}`}
                        className={`${styles.expr} ${_.isNil(firstKw) ? '' : styles[firstKw]}`}
                      >
                        {expr}
                      </span>,
                    ];
                  })}
                </div>
              )}
              control={{
                type: 'external',
                external: (
                  <Editor
                    editorState={scriptState}
                    onChange={this.handleChangeScript}
                  />
                ),
              }}
            />
            <ShowIf if={!editScript}>
              <div className={styles.actions}>
                <Link
                  className={styles.edit}
                  onClick={this.handleEditScript}
                >
                  <span className="glyphicons glyphicons-pencil" />
                </Link>
              </div>
            </ShowIf>
            <ShowIf if={editScript}>
              <div className={styles.actions}>
                <Link
                  className={styles.help}
                  onClick={() => { this.setState({ showHelp: !showHelp }); }}
                >
                  <span className="glyphicons glyphicons-question-sign" />
                </Link>
                <Link className={styles.ok} onClick={this.handleSubmitScript}>
                  <span className="glyphicons glyphicons-ok" />
                </Link>
                <Link
                  className={styles.cancel}
                  onClick={() => {
                    this.setState({
                      editScript: false,
                      errors: errors.remove('submitScript'),
                    });
                  }}
                >
                  <span className="glyphicons glyphicons-remove" />
                </Link>
              </div>
            </ShowIf>
          </div>
        </div>
        <FormBlock
          show={editScript && errors.has('submitScript')}
          message={this.intlMsg.errorMsg(errors.get('submitScript'))}
          azStyle="danger"
        />
        <Collapse in={showHelp && editScript}>
          <div className={styles.helpDoc}>
            <AddFlowHelp />
          </div>
        </Collapse>
        <DeleteFlowModal
          show={showDelete}
          flow={flow}
          onHide={() => { this.setState({ showDelete: false }); }}
          onDeleted={this.handleDeleted}
        />
      </div>
    );
  }
}

Flow.propTypes = propTypes;

const mapDispatchToProps = {
  getFlows: flowActions.getFlows,
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(Flow));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/FlowsView/coms/Flow/index.jsx